import React, {MouseEvent, ReactNode} from "react";
import {DeviceActiveResource, DeviceScheduleStatus, UUID} from "@barix/rpp-types";
import IconVolume from "../IconVolume";
import RppColors from "../../RppColors";
import {Tooltip} from "@mui/material";


class DeviceVolume extends React.Component<{
    device: {
        id: UUID;
        online: boolean;
        volume: number;
        muted: boolean;
        status: {
            activeResource: DeviceActiveResource;
            scheduleStatus: DeviceScheduleStatus;
        }
    } | undefined,
    basicRemoteController?: {
        setMuted?: (id: UUID, muted: boolean) => Promise<void>;
        setVolumeDelta?: (id: UUID, delta: number) => Promise<void>;
    },
    style?: React.CSSProperties;
}, {}> {

    private static getIconVolumeStyle(
        device: {
            online: boolean;
            muted: boolean;
            status: {
                activeResource: DeviceActiveResource;
                scheduleStatus: DeviceScheduleStatus;
            }
        } | undefined): React.CSSProperties {

        if (device && device.online && device.status && device.status.scheduleStatus !== "Inactive" && device.status.activeResource !== "NONE") {
            if (device.muted) {
                return {color: RppColors.deviceOffline()};
            }
            return {color: RppColors.deviceOnline()};
        }
        return {color: RppColors.deviceDisabled()};
    }


    private static getIconVolumeTitle(
        device: {
            online: boolean;
            volume: number;
            muted: boolean;
        } | undefined): NonNullable<React.ReactNode> {

        let prefix = "";
        if (device) {
            if (!device.online) {
                prefix = "Last volume: ";
            } else {
                prefix = "Volume: ";
            }
            return prefix + device.volume + "%" + (device.muted ? " | muted" : "");
        }
        return "";
    }


    public render(): ReactNode {
        if (this.props.device) {

            const hasHandlers = this.props.basicRemoteController && this.props.basicRemoteController.setMuted;
            const cursorStyle = hasHandlers ? {cursor: "pointer"} : {};

            return (
                <Tooltip title={DeviceVolume.getIconVolumeTitle(this.props.device)}>
                    <div
                        style={{...cursorStyle, ...DeviceVolume.getIconVolumeStyle(this.props.device)}}
                        onClick={this.onClickHandler}
                        onWheel={this.onWheelHandler}
                    >
                        {/*div is wrapper to hold css color*/}
                        <IconVolume
                            volume={this.props.device.volume}
                            muted={this.props.device.muted}
                            style={{fontSize: "1em", ...this.props.style}}
                        />
                    </div>
                </Tooltip>
            );
        } else {
            return (<IconVolume volume={0} muted={false} style={{...this.props.style}}/>);
        }
    }


    private onClickHandler = (event: MouseEvent<HTMLDivElement>) => {
        if (this.props.basicRemoteController && this.props.basicRemoteController.setMuted) {
            event.preventDefault();
            if (this.props.device) {
                this.props.basicRemoteController.setMuted(this.props.device.id, !this.props.device.muted).then();
            }
        }
    }


    private onWheelHandler = (event: React.WheelEvent<HTMLDivElement>) => {
        if (this.props.basicRemoteController && this.props.basicRemoteController.setVolumeDelta) {
            event.preventDefault();
            if (this.props.device) {
                if (event.deltaY < 0) {
                    // Utils.aLog(this, "Mouse wheel UP");
                    this.props.basicRemoteController.setVolumeDelta(this.props.device.id, +5).then();
                } else {
                    // Utils.aLog(this, "Mouse wheel DOWN");
                    this.props.basicRemoteController.setVolumeDelta(this.props.device.id, -5).then();
                }
            }
        }
    }

}


export default DeviceVolume;
